// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"328":"admin","443":"about"}[chunkId] + "." + {"328":"03185966","443":"e86085d1"}[chunkId] + ".js";
};